/**
 * Resolves a stale FAQ #anchor (from an old bookmark/backlink, after the
 * FAQ's title — and therefore its slug/anchor — has since changed) to
 * wherever that FAQ lives now.
 *
 * Cheap on the common path: bails immediately if there's no hash, or if
 * the hash already matches something on the page. The network lookup only
 * fires on an actual stale-anchor hit, which should be rare.
 */
export function maybeRedirectStaleFaqAnchor() {
  const hash = globalThis.location.hash.slice(1);
  if (!hash) return;
  if (document.getElementById(hash)) return;

  const restUrl = globalThis.unlk?.restUrl;
  if (!restUrl) return;

  fetch(`${restUrl}/faq-redirect?slug=${encodeURIComponent(hash)}`)
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      if (data?.url) globalThis.location.replace(data.url);
    })
    .catch(() => {});
}
